import IntegrityRoleGrid from 'components/UserRole';
import {Column, Lookup} from 'devextreme-react/data-grid';
import {i18n2} from 'features/i18n/i18n';
import React from 'react';
import {useIntegritySector} from '../hooks';

const lookupActive = {
  store: {
    type: 'array',
    data: [
      {id: 0, name: i18n2._('Planta Alberti')},
      {id: 1, name: i18n2._('Planta Santa Cruz')},
      {id: 2, name: i18n2._('Planta Pagola')},
      {id: 3, name: i18n2._('Planta Pilar')},
      {id: 4, name: i18n2._('Cochabamba')},
      {id: 5, name: i18n2._('Casa Central')},
    ],
    key: 'id',
  },
};

const SectorsGrid = (props: any) => {
  const loadSectors = useIntegritySector(props.data.key);
  return (
    <IntegrityRoleGrid
      dataSource={loadSectors}
      disabledExport={true}
      autoWidth={false}
      id={['iD_Sector']}
      height={'30vh'}
      allowIntegrity={false}
      allowActions={false}>
      <Column caption={i18n2._('#Sector')} dataField="iD_Sector" />
      <Column caption={i18n2._('Nombre')} dataField="name" width={200} />
      <Column
        caption={i18n2._('Colaborador responsable')}
        dataField="resp_Employee_Nr"
        dataType={'string'}
        // editorOptions
      />
      <Column caption={i18n2._('Activo en')} dataField="active" width={200}>
        <Lookup dataSource={lookupActive} valueExpr="id" displayExpr="name" />
      </Column>
      <Column caption={i18n2._('Gerencia')} dataField="management" />
      <Column caption={i18n2._('Revision')} dataField="revision" />
      <Column caption={i18n2._('Motivo')} dataField="reason" />
      <Column
        caption={i18n2._('Fecha de actualizacion')}
        visible={false}
        dataField="updateDate"
        defaultSortOrder={'desc'}
      />
      <Column
        caption={i18n2._('Actualizado por')}
        visible={false}
        dataField="updatedBy"
      />
      <Column caption={i18n2._('Eliminado')} dataField="deleted" width={100} />
    </IntegrityRoleGrid>
  );
};

export default SectorsGrid;
